// Constants not added as state variables
export const defaultRequiredMessage = 'THIS FIELD IS REQUIRED.';
export const paymentInfoSectionHeader = 'Payment information';

// Multimedia file upload limit
export const fileLimit = 5;
// Multimedia file name length limit
export const fileNameLength = 15;

// These are the screens in the checkout flow
export const screens = {
  multimedia: 'multimedia',
  review: 'review',
  crosspost: 'crosspost',
  newsletter: 'newsletter',
  payment: 'payment',
  confirmation: 'confirmation',
};
